export const imageExtensions = [
  'bmp',
  'cod',
  'gif',
  'ief',
  'jpe',
  'jpeg',
  'jpg',
  'jfif',
  'svg',
  'tif',
  'tiff',
  'ras',
  'cmx',
  'ico',
  'pnm',
  'pbm',
  'pgm',
  'ppm',
  'rgb',
  'xbm',
  'xwd',
] as const

export const videoExtensions = [
  'mp4', // ✅ Supported by Chrome & Safari
  'mov', // ✅ Supported by Chrome & Safari
  'webm', // ✅ Supported by Chrome only
  'ogv', // ✅ Supported by Chrome only
  'avi',
  'movie',
  'mp2',
  'mpa',
  'mpe',
  'mpeg',
  'mpg',
] as const

export const audioExtensions = [
  'mp3', // Supported
  'wav', // Supported
  'aac', // Supported
  'm4a', // Supported
  'ogg', // Chrome only
  'flac', // Chrome only
  'mpeg',
  'mid',
]

export const docExtensions = [
  'pptx',
  'xlsx',
  'doc',
  'docx',
  'txt',
  'rtf',
  'odt',
  'xls',
]

export const videoContentTypes = ['mp4', 'mov', 'webm', 'ogv']

export const audioContentTypes = ['m4a', 'mp3', 'wav', 'aac', 'ogg', 'flac']
